import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, withModifiers as _withModifiers, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass } from "vue";
const _hoisted_1 = { class: "data-item__header" };
const _hoisted_2 = { class: "data-item__nav" };
const _hoisted_3 = { class: "data-item__title" };
const _hoisted_4 = { class: "data-item__meta" };
const _hoisted_5 = { class: "data-item__facts" };
const _hoisted_6 = { class: "data-item__actions" };
const _hoisted_7 = { class: "data-item__content" };
const _hoisted_8 = {
    key: 0,
    class: "data-item__section"
};
const _hoisted_9 = { class: "data-properties data-properties--stacked" };
const _hoisted_10 = { class: "data-properties__property" };
const _hoisted_11 = { class: "data-properties__label" };
const _hoisted_12 = { class: "data-properties__value data-properties__value--emphasized" };
const _hoisted_13 = { class: "data-properties__property" };
const _hoisted_14 = { class: "data-properties__label" };
const _hoisted_15 = { class: "data-properties__value data-properties__value--emphasized" };
const _hoisted_16 = { class: "data-properties__property" };
const _hoisted_17 = { class: "data-properties__label" };
const _hoisted_18 = { class: "data-properties__value data-properties__value--emphasized" };
const _hoisted_19 = { class: "data-properties__property" };
const _hoisted_20 = { class: "data-properties__label" };
const _hoisted_21 = { class: "data-properties__value data-properties__value--emphasized" };
import { onMounted, ref, watch } from 'vue';
import { useRoute } from "vue-router";
import customerRepository from '@astina/paloma-shop-common-ui/src/services/CustomerRepository';
import Icon from "@astina/paloma-common-ui/src/components/Icon.vue";
import Spinner from "@astina/paloma-common-ui/src/components/Spinner.vue";
import Fact from "@astina/paloma-common-ui/src/components/Fact.vue";
import CommandButton from "@astina/paloma-common-ui/src/components/CommandButton.vue";
import DeleteUser from "../commands/DeleteUser";
import env from '../services/AppEnv';
import RouterUtils from "@astina/paloma-common-ui/src/util/RouterUtils";
export default /*@__PURE__*/ _defineComponent({
    __name: 'UserDetailsView',
    emits: [
        'close',
        'prev',
        'next'
    ],
    setup(__props, { emit: __emit }) {
        const route = useRoute();
        const emit = __emit;
        const user = ref(null);
        const deleteUser = ref(null);
        onMounted(loadUser);
        watch(() => route.params, loadUser);
        function loadUser() {
            user.value = null;
            const userId = RouterUtils.singleParam(route, 'id');
            customerRepository.getUser(userId).then(userParam => {
                user.value = userParam;
                deleteUser.value = userParam.username === env.user.username
                    ? null
                    : new DeleteUser(userId);
            });
        }
        function roleNames() {
            const roles = user.value.roles
                .map(role => role.label);
            return roles.length === 0
                ? ''
                : roles
                    .sort()
                    .reduce((r1, r2) => `${r1}, ${r2}`);
        }
        // --
        function closeView() {
            emit('close');
        }
        function prevItem() {
            emit('prev');
        }
        function nextItem() {
            emit('next');
        }
        return (_ctx, _cache) => {
            const _component_router_link = _resolveComponent("router-link");
            return (_openBlock(), _createElementBlock("div", {
                class: _normalizeClass(["data-item user", { 'user--loading': !user.value }])
            }, [
                _createElementVNode("header", _hoisted_1, [
                    _createElementVNode("div", _hoisted_2, [
                        _createElementVNode("a", {
                            onClick: _cache[0] || (_cache[0] = _withModifiers(($event) => (prevItem()), ["prevent"])),
                            class: "data-item__nav-item",
                            href: ""
                        }, [
                            _createVNode(Icon, { name: "angle-left" })
                        ]),
                        _cache[3] || (_cache[3] = _createTextVNode()),
                        _createElementVNode("a", {
                            onClick: _cache[1] || (_cache[1] = _withModifiers(($event) => (closeView()), ["prevent"])),
                            class: "data-item__nav-item",
                            href: ""
                        }, [
                            _createVNode(Icon, { name: "times" })
                        ]),
                        _cache[4] || (_cache[4] = _createTextVNode()),
                        _createElementVNode("a", {
                            onClick: _cache[2] || (_cache[2] = _withModifiers(($event) => (nextItem()), ["prevent"])),
                            class: "data-item__nav-item",
                            href: ""
                        }, [
                            _createVNode(Icon, { name: "angle-right" })
                        ])
                    ]),
                    _cache[8] || (_cache[8] = _createTextVNode()),
                    (user.value)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                            _createElementVNode("h1", _hoisted_3, _toDisplayString(((user.value.firstName || '') + ' ' + (user.value.lastName || '')).trim() || user.value.username), 1),
                            _cache[7] || (_cache[7] = _createTextVNode()),
                            _createElementVNode("div", _hoisted_4, [
                                _createElementVNode("div", _hoisted_5, [
                                    _createVNode(Fact, {
                                        label: _ctx.$t('user.status'),
                                        value: _ctx.$t('user.status_' + (user.value.enabled ? 'enabled' : 'disabled')),
                                        variant: user.value.enabled ? 'success' : undefined
                                    }, null, 8, ["label", "value", "variant"])
                                ]),
                                _cache[6] || (_cache[6] = _createTextVNode()),
                                _createElementVNode("div", _hoisted_6, [
                                    _createVNode(_component_router_link, {
                                        to: { name: 'config_users_edit', params: { id: user.value.id } },
                                        class: "button"
                                    }, {
                                        default: _withCtx(() => [
                                            _createVNode(Icon, { name: "edit" }),
                                            _createTextVNode(" " + _toDisplayString(_ctx.$t('user.edit')), 1)
                                        ]),
                                        _: 1
                                    }, 8, ["to"]),
                                    _cache[5] || (_cache[5] = _createTextVNode()),
                                    (deleteUser.value)
                                        ? (_openBlock(), _createBlock(CommandButton, {
                                            key: 0,
                                            command: deleteUser.value,
                                            classes: ['button', 'button--icon', 'button--danger'],
                                            onSuccess: closeView,
                                            label: ""
                                        }, null, 8, ["command"]))
                                        : _createCommentVNode("", true)
                                ])
                            ])
                        ], 64))
                        : (_openBlock(), _createBlock(Spinner, {
                            key: 1,
                            loading: !user.value
                        }, null, 8, ["loading"]))
                ]),
                _cache[16] || (_cache[16] = _createTextVNode()),
                _createElementVNode("div", _hoisted_7, [
                    (user.value)
                        ? (_openBlock(), _createElementBlock("section", _hoisted_8, [
                            _createElementVNode("div", _hoisted_9, [
                                _createElementVNode("div", _hoisted_10, [
                                    _createElementVNode("div", _hoisted_11, _toDisplayString(_ctx.$t('user.full_name')), 1),
                                    _cache[9] || (_cache[9] = _createTextVNode()),
                                    _createElementVNode("div", _hoisted_12, _toDisplayString(((user.value.firstName || '') + ' ' + (user.value.lastName || '')).trim() || '-'), 1)
                                ]),
                                _cache[13] || (_cache[13] = _createTextVNode()),
                                _createElementVNode("div", _hoisted_13, [
                                    _createElementVNode("div", _hoisted_14, _toDisplayString(_ctx.$t('email')), 1),
                                    _cache[10] || (_cache[10] = _createTextVNode()),
                                    _createElementVNode("div", _hoisted_15, _toDisplayString(user.value.emailAddress), 1)
                                ]),
                                _cache[14] || (_cache[14] = _createTextVNode()),
                                _createElementVNode("div", _hoisted_16, [
                                    _createElementVNode("div", _hoisted_17, _toDisplayString(_ctx.$t('user.roles')), 1),
                                    _cache[11] || (_cache[11] = _createTextVNode()),
                                    _createElementVNode("div", _hoisted_18, _toDisplayString(roleNames()), 1)
                                ]),
                                _cache[15] || (_cache[15] = _createTextVNode()),
                                _createElementVNode("div", _hoisted_19, [
                                    _createElementVNode("div", _hoisted_20, _toDisplayString(_ctx.$t('user.locale')), 1),
                                    _cache[12] || (_cache[12] = _createTextVNode()),
                                    _createElementVNode("div", _hoisted_21, _toDisplayString(user.value.locale), 1)
                                ])
                            ])
                        ]))
                        : _createCommentVNode("", true)
                ])
            ], 2));
        };
    }
});
